import { css } from '@emotion/react'
import { router } from '@lifedot/router'
import { Button } from '@lifedot/atoms/Button'
import { typography } from '@lifedot/styles/typography'
import Link from 'next/link'
import { FC } from 'react'

const styles = {
  link: css({
    textDecoration: 'none',
    marginTop: 8,
    display: 'block'
  })
}

interface DetailsProps {
  directorComment: string | null
  requestable: boolean
  cemeteryId: number
}

export const Details: FC<DetailsProps> = ({
  directorComment,
  requestable,
  cemeteryId
}) => {
  return (
    <>
      <p css={typography.textS}>{directorComment?.slice(0, 32)}…</p>
      <Link href={router.cemetery(cemeteryId)} passHref prefetch={false}>
        <a css={styles.link}>
          <Button
            mainText={<span>詳細を見る</span>}
            variant="secondary"
            as="div"
          />
        </a>
      </Link>
      {requestable && (
        <Link
          href={router.requestsNew({ id: cemeteryId })}
          passHref
          prefetch={false}
        >
          <a css={styles.link}>
            <Button
              mainText={<span>パンフレットを請求</span>}
              color="accent"
              as="div"
            />
          </a>
        </Link>
      )}
    </>
  )
}
